<template>
  <section
    class="slide sec3 whiteSlide kenBurns bg-white overflow-hidden opacity-0 fixed w-full h-full text-black"
  >
    <div class="content overflow-hidden absolute left-0 top-0 w-full h-full z-20">
      <div class="container max-w-full table w-full h-full table relative table-fixed">
        <div class="wrap cursor-default table-cell align-middle">
          <div class="fix-width max-w-1114px ml-auto mr-auto">
            <ul class="grid sec-details sec-details3 ml-spc16 mr-spc16">
              <li
                class="col-6-12 mt-spc13 max-w-589 w-full pl-6 pr-6 block text-center"
                id="productImage1"
              >
                <SliderOne :slideDatas="mjSliderData" />
              </li>
              <li class="col-6-12 left max-w-589 w-full pl-6 pr-6 block">
                <SectionDetailsContent
                  :title="title"
                  :subtitle="subtitle"
                  :sizes="sizes"
                  :prices="prices"
                  :colors="colors"
                  :fabrics="fabrics"
                  btn1title="Purchase"
                  btn2title="Enquiries"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SliderOne from "../sliders/slider1/SliderOne";
import SectionDetailsContent from "../common/SectionDetailsContent";

let mjSliderData = {
  sliderID: "30",
  mjSliders: [
    {
      active: true,
      img: require("@/assets/images/products/thumbfield1.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbfield2.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbfield3.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbfield4.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbfield5.png")
    }
  ]
};

export default {
  name: "Section8",
  components: {
    SectionDetailsContent,
    SliderOne
  },
  data() {
    return {
      mjSliderData,
      title: "MAD JAM & FIELD",
      subtitle: "THE FIELD",
      sizes: {
        sticks: "55” x 55” SQ"
      },
      colors: {
        clr: "Silver & Laurel Grey S"
      },
      fabrics: {
        fabric: "Welsh Flannel woven in Wales",
        fabric2: "Embroidered with ‘Yan Tan Tethera' (E)",
        fabric3: "or Welsh variation (W)"
      },
      prices: {
        price1: "$420"
      }
    };
  }
};
</script>

<style scoped>
</style>